// extracted by mini-css-extract-plugin
module.exports = {"loginFormContainer":"_05dff3e","loginFormHeading":"_00ab5d9","buttonWrapper":"_e333228","loginButton":"_7c2e203"};